import { useState, Suspense, lazy } from 'react';
import { Grid, Tab, Tabs, Box } from '@mui/material';

const Asistencia = lazy(() => import('./Asistencia/Asistencia'));
const ScheduledMessage = lazy(() => import('./ScheduledMessage/ScheduledMessage'));
const States = lazy(() => import('./States/States'));
const FilterPendingAppointments = lazy(() =>
  import('./FilterPendingAppointments/FilterPendingAppointments'),
);
const CustomizedMessages = lazy(() => import('./CustomizedMessages/CustomizedMessages'));
const ChatsAlerts = lazy(() => import('./ChatAlerts/ChatAlerts'));
const Appointments = lazy(() => import('./Appointments/Appointments'));
const RemindersSettings = lazy(() => import('./RemindersSettings/RemindersSettings'));
export default function ClientConfiguration() {
  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    e && e.preventDefault();
    setValue(newValue);
  };

  const tabComponents = [
    <Suspense key="asistencia" fallback={<div>...</div>}>
      <Asistencia />
    </Suspense>,
    <Suspense key="MensajeAgenda" fallback={<div>...</div>}>
      <ScheduledMessage />
    </Suspense>,

    <Suspense key="States" fallback={<div>...</div>}>
      <States />
    </Suspense>,
    <Suspense key="ChatsAlerts" fallback={<div>...</div>}>
      <ChatsAlerts />
    </Suspense>,
    <Suspense key="AppointmentsSettings" fallback={<div>...</div>}>
      <Appointments />
    </Suspense>,
    <Suspense key="RemindersSettings" fallback={<div>...</div>}>
      <RemindersSettings />
    </Suspense>,
    <Suspense key="FilterPendingAppointments" fallback={<div>...</div>}>
      <FilterPendingAppointments />
    </Suspense>,
    <Suspense key="CustomizedMessages" fallback={<div>...</div>}>
      <CustomizedMessages />
    </Suspense>,
  ];

  const filteredTabComponents = tabComponents.filter((component) => component !== null);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 1, mb: 2, p: 3, boxShadow: 2, borderRadius: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{ style: { background: 'yellow' } }}
      >
        <Tab label="Asistencia" />
        <Tab label="Mensajes Programados" />
        <Tab label="Estados de chat" />
        <Tab label="Alertas de chat" />
        <Tab label="Configuración de Turnos" />
        <Tab label="Configuración de Recordatorios" />
        <Tab label="Filtro Turnos Pendientes" />
        <Tab label="Mensajes personalizados (nuevo)" />
      </Tabs>
      <Grid container style={{ marginTop: '23px' }}>
        {filteredTabComponents[value]}
      </Grid>
    </Box>
  );
}
